var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX2Y2Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459.265 100.353C420.038 62.0229 366.378 38.4 307.2 38.4C187.023 38.4 89.6 135.823 89.6 256C89.6 376.177 187.023 473.6 307.2 473.6C366.377 473.6 420.038 449.977 459.265 411.647C412.474 472.661 338.831 512 256 512C114.615 512 0 397.385 0 256C0 114.615 114.615 0 256 0C338.831 0 412.474 39.339 459.265 100.353Z",
    fill: "url(#paint0_linear_3_635)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.588 380.518C175.97 411.182 218.898 430.08 266.24 430.08C362.382 430.08 440.32 352.142 440.32 256C440.32 159.858 362.382 81.92 266.24 81.92C218.898 81.92 175.97 100.818 144.588 131.482C182.021 82.6712 240.935 51.2 307.2 51.2C420.308 51.2 512 142.892 512 256C512 369.108 420.308 460.8 307.2 460.8C240.935 460.8 182.021 429.329 144.588 380.518Z",
    fill: "url(#paint1_linear_3_635)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.6 256C409.6 340.831 340.831 409.6 256 409.6C171.169 409.6 102.4 340.831 102.4 256C102.4 171.169 171.169 102.4 256 102.4C340.831 102.4 409.6 171.169 409.6 256ZM358.4 256C358.4 312.554 312.554 358.4 256 358.4C199.446 358.4 153.6 312.554 153.6 256C153.6 199.446 199.446 153.6 256 153.6C312.554 153.6 358.4 199.446 358.4 256Z",
    fill: "url(#paint2_linear_3_635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_635",
    x1: 0,
    y1: 247.172,
    x2: 512,
    y2: 247.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562EC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_635",
    x1: 0,
    y1: 247.172,
    x2: 512,
    y2: 247.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562EC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_635",
    x1: 0,
    y1: 247.172,
    x2: 512,
    y2: 247.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562EC8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2Y2Logo);
export default __webpack_public_path__ + "static/media/x2y2_logo.624ca8c37d047db7b5919df00d4a43d3.svg";
export { ForwardRef as ReactComponent };